export const COMPS_PER_TABLE = 3;

export const COST_APPROACH_COLUMN_WIDTHS = ['40%', '20%', '20%', '20%'];

export const COST_APPROACH_FIVE_COLUMN_WIDTHS = ['40%', '13.33%', '13.33%', '13.34%', '20%'];
